<!--
  Copyright 2023 The Ground Authors.

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at

      https://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
-->

<div
  *ngIf="surveyOwnerEmail && acl"
  class="share-list-container"
>
  <mat-list>
    <mat-list-item>
      <div class="survey-owner-list-item">
        <div>{{surveyOwnerEmail}}</div>

        <div class="survey-owner-label">Survey owner</div>
      </div>
    </mat-list-item>

    <ng-container *ngFor="let entry of acl; let i = index;">
      <ng-container *ngIf="surveyOwnerEmail !== entry.email;">
        <mat-divider></mat-divider>

        <mat-list-item>
          <div matListItemTitle>
            {{entry.email}}
          </div>
          <mat-form-field subscriptSizing="dynamic" matListItemMeta>
            <mat-select
              class="role-select"
              (selectionChange)="onRoleChange($event, i)"
              [value]="entry.role"
            >
              <mat-option
                *ngFor="let option of roleOptions"
                [value]="option.value"
                >{{ option.label }}</mat-option
              >
              <mat-option value="-1" class="remove-option">Remove</mat-option>
            </mat-select>
          </mat-form-field>
        </mat-list-item>
      </ng-container>
    </ng-container>
  </mat-list>
</div>
